import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles/index';
import Transition from './Transition';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	actions: {
		padding: 10,
	},
});

class ChangeDeliveryIdDialog extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			bulkDeliveryId: '',
		};
	}

	onChange = (event, fieldName) => {
		this.setState({ [fieldName]: event.target.value });
	};

	handleClose = () => {
		this.setState({ bulkDeliveryId: '' });
		this.props.onClose();
	};

	handleSubmit = () => {
		const { showErrors, ocrIngestionResultId, overrideMatchData } = this.props;
		const { bulkDeliveryId } = this.state;

		if (!bulkDeliveryId) {
			showErrors(['Bulk Delivery ID is required.']);
			return;
		}

		const deliveryId = parseInt(bulkDeliveryId, 10);
		if (!_.isNumber(deliveryId) || _.isNaN(deliveryId)) {
			showErrors(['Bulk Delivery ID must be a valid number.']);
			return;
		}

		overrideMatchData({
			params: {
				ocrIngestionResultId,
				bulkDeliveryId: deliveryId,
			},
			callback: (err, result) => {
				if (err) {
					showErrors([err]);
					return;
				}
				// Close dialog on success
				console.log(result);
				this.handleClose();
			},
		});
	};

	render() {
		const { classes, open } = this.props;
		return (
			<Dialog
				maxWidth="sm"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<DialogTitle>Change Delivery ID</DialogTitle>
				<DialogContent>
					<TextField
						value={this.state.bulkDeliveryId}
						onChange={(event) => this.onChange(event, 'bulkDeliveryId')}
						label="Bulk Delivery ID"
						fullWidth
						type="number"
						placeholder="Enter new bulk delivery ID"
					/>
				</DialogContent>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>Cancel</Button>
						<Button variant="contained" onClick={this.handleSubmit} color="primary">
							Submit
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ChangeDeliveryIdDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	ocrIngestionResultId: PropTypes.number.isRequired,
	overrideMatchData: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ChangeDeliveryIdDialog);
